import { useState, useEffect } from "react"

export default function useInView(ref) {
    const isClient = typeof window === 'object'
    const [percent, setPercent] = useState(null)

    const isVisible = (elem) => {
        const bounds = elem.getBoundingClientRect()
        if (bounds) {
            const { bottom, top } = bounds
            const headerHeight = 87.5 // pixels
            const windowHeight = window.innerHeight - headerHeight
            const middle = (bottom + top) / 2 - headerHeight
            setPercent(1 - (middle / (windowHeight)))

        }
    }
    useEffect(() => {
        if (ref.current && isClient) {
            if (!percent) { isVisible(ref.current) }
            window.addEventListener("scroll", () => {
                isVisible(ref.current)
            })
        }
        return window.removeEventListener("scroll", () => {
            isVisible(ref.current)
        })
    }, [ref.current])

    if (percent < 0) {
        return 0
    }
    if (percent > 1) {
        return 100
    }
    return percent * 100
}